import ImageZoom from "../components/ImageZoom/ImageZoom";

export default function ImageZoomPage() {
	return <ImageZoom />;
}
